import { routesNames } from '@/core/constants'
import BaixarRelatorioControleSaldos from '@/views/pages/relatorios/controle-saldos/BaixarRelatorioControleSaldos'
import BaixarRelatorioControleAdesoes from '@/views/pages/relatorios/controle-adesoes/BaixarRelatorioControleAdesoes'

export default [
	{
		name: routesNames.RELATORIOS.BAIXAR.CONTROLE_SALDOS,
		path: '/relatorios/:idDocumento/baixar/controle-saldos',
		component: BaixarRelatorioControleSaldos,
	},
	{
		name: routesNames.RELATORIOS.BAIXAR.CONTROLE_ADESOES,
		path: '/relatorios/:idDocumento/baixar/controle-adesoes',
		component: BaixarRelatorioControleAdesoes,
	},
]
